/**
 * Overwritten by scripts/inject-mixpanel-env.js in CI.
 */
export const MIXPANEL_TOKEN = "8bb619802923176310c67a7246564a5a"
